module.exports = __webpack_public_path__ + "static/vo-6630da55f6d4a94f3956a96bdff66e93.mp3";